module.exports = __webpack_public_path__ + "img/bg.63d18322.png";